import i18n from "../../i18n";
import styles from "./closeButton.module.css";

function CloseButton({ onClick }: { onClick: () => void }) {
  return <button dir={i18n.dir()} className={`${styles.closeBtn} hover`} onClick={onClick} />;
}

export default CloseButton;
